module.exports = __webpack_public_path__ + "static/media/logo_black.121bf5c8.png";